var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5H2C1.17157 2.5 0.5 3.17157 0.5 4V14C0.5 14.8284 1.17157 15.5 2 15.5H8C8.82843 15.5 9.5 14.8284 9.5 14V4C9.5 3.17157 8.82843 2.5 8 2.5Z",
    stroke: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2C2.5 1.60218 2.65804 1.22064 2.93934 0.93934C3.22064 0.658035 3.60218 0.5 4 0.5H10C10.3978 0.5 10.7794 0.658035 11.0607 0.93934C11.342 1.22064 11.5 1.60218 11.5 2V12C11.5 12.3978 11.342 12.7794 11.0607 13.0607C10.7794 13.342 10.3978 13.5 10 13.5",
    stroke: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.3b0efb6080322758df894e2fd423f112.svg";
export { ForwardRef as ReactComponent };